<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Komponenten verwalten' | mrTranslate }}</span>
    </div>
    <div class="header-actions">
      <a href="javascript://" class="nav-link nav-icon">
        <cds-icon shape="times" (click)="close()"></cds-icon>
      </a>
    </div>
  </header>
  <div class="clr-row nxm" style="align-items: center">
    <div class="clr-col-auto margin-12-tb">
      <div class="btn-group btn-primary btn-icon">
        <button class="btn btn-icon btn-success" [title]="'Neu' | mrTranslate" (click)="newitem()">
          <cds-icon shape="file" />
        </button>

        <button class="btn btn-icon margin-12-l" [title]="'Import' | mrTranslate" (click)="importitem()">
          <!--[disabled]="selOKOMPID == 0"> -->
          <cds-icon shape="import" />
        </button>

        <button
          class="btn btn-icon btn-danger"
          [title]="'Löschen' | mrTranslate"
          (click)="deletitem()"
          [disabled]="selOKOMPID == 0">
          <cds-icon shape="times" />
        </button>
      </div>
    </div>
  </div>

  <div class="clr-row nxm" style="margin-top: -20px">
    <div class="clr-col-4">
      <h4>{{ 'Komponenten' | mrTranslate }}</h4>
      @if (rootObjekt) {
        <div class="content-area">
          <clr-tree>
            <clr-tree-node
              *clrRecursiveFor="let item of rootObjekt; getChildren: getChildren"
              [(clrExpanded)]="item.expanded"
              [ngClass]="
                item == selnode && item.children.length == 0 ?
                  isDarkThemeAktiv ? 'highlighted'
                  : 'highlightedhell'
                : ''
              ">
              <a class="clr-treenode-link" [class.active]="item == selnode" (click)="treeClick(item)">
                {{ item.name }}
              </a>
            </clr-tree-node>
          </clr-tree>
          <br />
          <br />
        </div>
      }
    </div>
    @if (spezData.length > 0) {
      <div class="clr-col-8">
        <h4>{{ 'Eigenschaften' | mrTranslate }} {{ selnodename }}</h4>

        <form #spezFormPoint clrForm ngForm (ngSubmit)="saveIfValid()" class="width100 margin-12-t" clrLabelSize="12">
          <table class="table margin-0-t table-compact nowrap">
            <thead style="position: sticky; top: 0; z-index: 3">
              <tr>
                <th class="left">{{ 'Objekt' | mrTranslate }}</th>
                <th class="left" style="width: 50%">{{ 'Bezeichnung' | mrTranslate }}</th>
                <th>{{ 'Tabelle' | mrTranslate }}</th>
                <th>{{ 'Pflicht' | mrTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (spez of spezData; track $index) {
                <tr [hidden]="spez.objekt == 'OSPEZID'">
                  @if (!spez.isHeader) {
                    <td class="left" style="vertical-align: bottom">
                      {{ spez.objekt | mrTranslate }}
                    </td>
                    <td>
                      @switch (spez.fieldType) {
                        @case ('str') {
                          @if (spez.sField) {
                            <!-- ! STRIKT Texteingabefeld nur vom Tabelle -->
                            <clr-select-container>
                              <select
                                clrSelect
                                [name]="spez.objekt"
                                [(ngModel)]="spez.bezeichnung"
                                [required]="!!spez.pflichtFeld"
                                [inTableValidator]="spez.wListe">
                                <option [disabled]="spez.pflichtFeld" value=""></option>
                                @if (spez.bezeichnung && !spez.wListe.includes(spez.bezeichnung)) {
                                  <option [value]="spez.bezeichnung" class="invalid-red">{{ spez.bezeichnung }}</option>
                                }
                                @for (wert of spez.wListe; track $index) {
                                  <option [value]="wert">{{ wert }}</option>
                                }
                              </select>
                              <clr-control-error *clrIfError="'not-in-Table'; error as err">
                                {{ err | mrTranslate }}
                              </clr-control-error>
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-select-container>
                          } @else {
                            <!-- * FREI Texteingabefeld mit den bisherigen Werten -->
                            <clr-datalist-container>
                              <input
                                class="clr-col-12"
                                clrDatalistInput
                                type="search"
                                [name]="spez.objekt"
                                [(ngModel)]="spez.bezeichnung"
                                [required]="!!spez.pflichtFeld" />
                              <datalist>
                                @for (wert of spez.wListe; track $index) {
                                  <option [value]="wert"></option>
                                }
                              </datalist>
                              <clr-control-error *clrIfError="'required'">
                                {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                              </clr-control-error>
                            </clr-datalist-container>
                          }
                        }
                        @case ('dbl') {
                          <ng-container *ngTemplateOutlet="number; context: { float: true }" />
                        }
                        @case ('int') {
                          <ng-container *ngTemplateOutlet="number; context: { float: false }" />
                        }
                        @case ('chk') {
                          <!-- Ja/Nein Einegabe -->
                          <clr-toggle-container>
                            <clr-toggle-wrapper>
                              <input type="checkbox" clrToggle [name]="spez.objekt" [(ngModel)]="spez.bezeichnung" />
                            </clr-toggle-wrapper>
                          </clr-toggle-container>
                        }
                        @case ('dat') {
                          <!-- Datum -->
                          <clr-date-container>
                            <input
                              clrDate
                              [name]="spez.objekt"
                              autocomplete="off"
                              type="date"
                              [required]="!!spez.pflichtFeld"
                              [ngModel]="spez.bezeichnung | localeDate"
                              (ngModelChange)="spez.bezeichnung = localeDate.tosql($event)"
                              [ngModelOptions]="{ updateOn: 'blur' }" />
                            <clr-control-error *clrIfError="'required'">
                              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                            </clr-control-error>
                          </clr-date-container>
                        }
                      }
                      <ng-template #number let-float="float">
                        <clr-input-container>
                          <input
                            clrInput
                            [name]="spez.objekt"
                            [(ngModel)]="spez.bezeichnung"
                            type="number"
                            [step]="float ? 0.1 : 1"
                            [required]="!!spez.pflichtFeld" />
                          <clr-control-error *clrIfError="'required'">
                            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                          </clr-control-error>
                        </clr-input-container>
                      </ng-template>
                    </td>
                    <td>
                      @if (spez.sField) {
                        <cds-icon
                          [title]="'Liste bearbeiten' | mrTranslate"
                          shape="pencil"
                          size="20"
                          (click)="openTabelle(spez)" />
                      }
                    </td>
                    <td>
                      @if (spez.pflichtFeld) {
                        <cds-icon shape="success-standard" solid="true" style="fill: #2ec0ff" />
                      }
                    </td>
                  } @else {
                    <th class="headerRow left">
                      {{ spez.objekt | mrTranslate }}
                    </th>
                    <th class="headerRow"></th>
                    <th class="headerRow"></th>
                    <th class="headerRow"></th>
                  }
                </tr>
              }
            </tbody>
          </table>
        </form>
        @if (selnode) {
          <div class="clr-row nxm padding-24-b">
            <div class="clr-col-12">
              <app-preview-thumbnails
                [acceptTypes]="'image/*'"
                [maxAmount]="6"
                [allowCameraVideo]="false"></app-preview-thumbnails>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="ngForm.ngSubmit.emit()">
              {{ 'Speichern' | mrTranslate }}
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>

<clr-modal [(clrModalOpen)]="isnewAdd" [clrModalClosable]="true" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'Komponenten auswählen' | mrTranslate }}</h3>
  <div class="modal-body">
    <div class="content-container">
      @if (root) {
        <div class="content-area">
          <clr-tree>
            <clr-tree-node
              *clrRecursiveFor="let item of root; getChildren: getChildren"
              [(clrSelected)]="item.selected"
              [(clrExpanded)]="item.expanded">
              <a class="clr-treenode-link" [class.active]="item.selected">{{ item.name }}</a>
            </clr-tree-node>
          </clr-tree>
          <br />
          <br />
        </div>
      }
    </div>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addKompItems()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="isnewAdd = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="objekteModal" [clrModalClosable]="true" [clrModalSize]="'xl'">
  <h3 class="modal-title">{{ 'Komponenten importieren' | mrTranslate }}</h3>
  <div class="modal-body">
    <div class="clr-row nxm">
      <div class="clr-col-7">
        <h5>{{ 'Objektauswahl' | mrTranslate }}</h5>
        @if (objekte?.rows?.length > 0 && objekteModal) {
          <clr-datagrid
            class="datagrid-compact"
            style="height: 650px"
            [clrDgSelectionType]="'single'"
            [clrDgSelected]="[selectedObjekt]"
            (clrDgSelectedChange)="selectedObjekt = $event[0]; selectionGridChanged($event[0])"
            [clrDgRowSelection]="true">
            @for (column of objekte.columns; track $index) {
              <clr-dg-column [clrDgField]="column.id" [style.min-width.px]="column.id.length * 7.5 + 26">
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sp', 'lf', 'st', 'rep'] }">
                  {{ column.id | titlecase | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row *clrDgItems="let row of objekte.rows" [clrDgItem]="row">
              @for (cell of objekte.columns; track $index) {
                <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
              }
            </clr-dg-row>
            <clr-dg-footer>{{ objekte.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        }
      </div>

      <div class="clr-col-5">
        @if (rootObjektImport) {
          <div class="content-area">
            <h5>{{ 'Komponenten auswählen' | mrTranslate }}</h5>
            <clr-tree>
              <clr-tree-node
                *clrRecursiveFor="let item of rootObjektImport; getChildren: getChildren"
                [(clrSelected)]="item.selected"
                [(clrExpanded)]="item.expanded">
                <a class="clr-treenode-link" [class.active]="item.selected">{{ item.name }}</a>
              </clr-tree-node>
            </clr-tree>
            <br />
            <br />
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="importKomponent()">{{ 'Importieren' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="objekteModal = false">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>

<app-baseitems-wrapper [(isModalOpen)]="isBaseItemModalOpen" [route]="editTabelle()" />
